export function isCurrentPlayerSuspension(suspension, today) {
  if (suspension?.suspension_type === "games") {
    return Number(suspension.games_suspended || 0) > 0;
  }
  return !suspension?.end_date || suspension.end_date >= today;
}
